var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBell = function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19.7 16.5h1.8v1.8h-18v-1.8h1.8v-6.3a7.2 7.2 0 1 1 14.4 0zm-1.8 0v-6.3a5.4 5.4 0 1 0-10.8 0v6.3zm-8.1 3.6h5.4v1.8H9.8z"
  })));
};
export default SvgBell;